// client/src/constants/formData.js
// Static data for SendListing form

export const GEORGIAN_CITIES = [
    // Special Option
    { en: 'All Georgia', ka: 'მთელი საქართველო' },      // 🇬🇪 Nationwide service coverage

    // Major Cities
    { en: 'Tbilisi', ka: 'თბილისი' },          // Capital - largest business hub
    { en: 'Batumi', ka: 'ბათუმი' },           // Adjara region capital - port & tourism
    { en: 'Kutaisi', ka: 'ქუთაისი' },          // Historical capital - western Georgia
    { en: 'Rustavi', ka: 'რუსთავი' },          // Industrial city near Tbilisi

    // Regional Centers
    { en: 'Gori', ka: 'გორი' },             // Shida Kartli region
    { en: 'Zugdidi', ka: 'ზუგდიდი' },          // Samegrelo region capital
    { en: 'Poti', ka: 'ფოთი' },             // Major port city
    { en: 'Telavi', ka: 'თელავი' },           // Kakheti region capital - wine region
    { en: 'Ozurgeti', ka: 'ოზურგეთი' },         // Guria region capital
    { en: 'Ambrolauri', ka: 'ამბროლაური' },       // Racha region capital

    // Important Towns
    { en: 'Kobuleti', ka: 'ქობულეთი' },         // Coastal resort town
    { en: 'Khashuri', ka: 'ხაშური' },         // Railway junction
    { en: 'Samtredia', ka: 'სამტრედია' },        // Regional center
    { en: 'Senaki', ka: 'სენაკი' },           // Military base city
    { en: 'Zestaponi', ka: 'ზესტაფონი' },        // Industrial center
    { en: 'Marneuli', ka: 'მარნეული' },         // Agricultural center
    { en: 'Akhalkalaki', ka: 'ახალქალაქი' },      // Samtskhe region
    { en: 'Lagodekhi', ka: 'ლაგოდეხი' },        // Border town with Azerbaijan
    { en: 'Bolnisi', ka: 'ბოლნისი' },          // Historical city
    { en: 'Gardabani', ka: 'გარდაბანი' },        // Industrial city

    // Additional Cities
    { en: 'Akhaltsikhe', ka: 'ახალციხე' },      // Samtskhe-Javakheti region
    { en: 'Mtskheta', ka: 'მცხეთა' },         // Ancient capital
    { en: 'Kaspi', ka: 'კასპი' },            // Regional town
    { en: 'Kvareli', ka: 'ყვარელი' },          // Wine region
    { en: 'Sighnaghi', ka: 'სიღნაღი' },        // Tourism - "City of Love"
    { en: 'Gurjaani', ka: 'გურჯაანი' },         // Kakheti region
    { en: 'Dusheti', ka: 'დუშეთი' },          // Mountain region
    { en: 'Tianeti', ka: 'თიანეთი' },          // Mountain region
    { en: 'Kareli', ka: 'ქარელი' },           // Shida Kartli
    { en: 'Khoni', ka: 'ხონი' },            // Imereti region
];

// BUSINESS_CATEGORIES removed - now fetched dynamically from API
// Categories are managed through the admin panel and fetched from /api/submissions/categories
// This ensures admin control over which categories are available for submissions
//citycionfig collection is in mongoDB however not wired up with cleint and backend side so far, thus page uses static list yet